import { createSelector } from 'reselect';

import { TIMING_DEFAULT } from '../constants';
import { selectRawFilterData } from './general';

const [
    TIMING_MIN_DEFAULT,
    TIMING_MAX_DEFAULT,
] = TIMING_DEFAULT;

function selectTimingFilterData(state, filterId) {
    return selectRawFilterData(state, filterId).timing;
}

function _isDepartureTimingFiltered(timingMap) {
    const [min, max] = Object.values(timingMap.departure);
    return min !== TIMING_MIN_DEFAULT || max !== TIMING_MAX_DEFAULT;
}

const selectDepartureTimingIsFiltered = createSelector(
    selectTimingFilterData,
    _isDepartureTimingFiltered,
);

function _isArrivalTimingFiltered(timingMap) {
    const [min, max] = Object.values(timingMap.arrival);
    return min !== TIMING_MIN_DEFAULT || max !== TIMING_MAX_DEFAULT;
}

const selectArrivalTimingIsFiltered = createSelector(
    selectTimingFilterData,
    _isArrivalTimingFiltered,
);

export {
    selectArrivalTimingIsFiltered,
    selectDepartureTimingIsFiltered,
    selectTimingFilterData,
};
